angular.module('dpw.services').factory('clientInfo', ['api', '$q', function (api, $q) {
    var store = {
        prodUrls: {}
    };

    var utils = {
        prodUrlsPromise: updateProdUrls()
    };

    return {
        getProdServiceWebUrl: getProdServiceWebUrl,
        getProdResetPasswordUrl: getProdResetPasswordUrl
    };

    function getProdServiceWebUrl() {
        return utils.prodUrlsPromise.then(function (prodUrls) {
            var url = _.get(prodUrls, 'serviceWeb');
            if (url) return url;

            return invalidateProdUrls().then(function (prodUrls) {
                return _.get(prodUrls, 'serviceWeb', '');
            });
        });
    }

    function getProdResetPasswordUrl() {
        return utils.prodUrlsPromise.then(function (prodUrls) {
            var url = _.get(prodUrls, 'resetPassword');
            if (url) return url;

            return invalidateProdUrls().then(function (prodUrls) {
                return _.get(prodUrls, 'resetPassword', '');
            });
        });
    }

    function updateProdUrls() {
        return $q(function (resolve) {
            api.call(api.myAccount.applications.clientInfo(), function (data) {
                resolve(store.prodUrls = transformProdFormat(data));
            }, function () {
                resolve(store.prodUrls = transformProdFormat({}));
            });
        });
    }

    function invalidateProdUrls() {
        return utils.prodUrlsPromise = updateProdUrls();
    }

    function transformProdFormat(data) {
        return {
            'serviceWeb': data.serviceWebHome,
            'resetPassword': data.serviceWebResetPassword
        };
    }
}]);
